import React, { useState, useEffect, useRef } from 'react';

const BASE_URL = 'https://api.app.pixventa.com';
const EMOJIS = ['👗','👕','👖','🧥','👜','👠','💄','🧣','👒','💍'];
const ORDEN_TALLAS = ['XS','S','M','L','XL','XXL','XXXL','2XL','3XL',
  '0','2','4','6','8','10','12','14','16','18','20',
  '28','30','32','34','36','38','40','42','44','ÚNICA','UNICA'];

function ordenarOpciones(arr) {
  return [...arr].sort((a, b) => {
    const iA = ORDEN_TALLAS.indexOf((a.nombre || '').toUpperCase());
    const iB = ORDEN_TALLAS.indexOf((b.nombre || '').toUpperCase());
    if (iA === -1 && iB === -1) return (a.nombre || '').localeCompare(b.nombre || '');
    if (iA === -1) return 1;
    if (iB === -1) return -1;
    return iA - iB;
  });
}

function ModalEditarProducto({ producto, onCerrar, onGuardado }) {
  const [emoji,       setEmoji]       = useState(producto.emoji || '👗');
  const [nombre,      setNombre]      = useState(producto.nombre || '');
  const [descripcion, setDescripcion] = useState(producto.descripcion || '');
  const [precio,      setPrecio]      = useState(
    parseFloat(producto.precio).toLocaleString('es-MX', { minimumFractionDigits: 2 })
  );
  const [guardando, setGuardando] = useState(false);

  const [todosGrupos,  setTodosGrupos]  = useState([]);
  const [ordenGrupos,  setOrdenGrupos]  = useState([]);
  const [estadoGrupos, setEstadoGrupos] = useState({});

  const [nuevoGrupoAbierto, setNuevoGrupoAbierto] = useState(false);
  const [nuevoGrupoSel,     setNuevoGrupoSel]     = useState(null);
  const [nuevasOpciones,    setNuevasOpciones]     = useState([]);

  const [addingOpcion,      setAddingOpcion]      = useState(null);
  const [nuevaOpcionNombre, setNuevaOpcionNombre] = useState('');
  const [nuevaOpcionHex,    setNuevaOpcionHex]    = useState('#ff9a9e');

  const dragSrc = useRef(null);

  useEffect(() => { cargarGrupos(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function cargarGrupos() {
    const res  = await fetch(`${BASE_URL}/variante-grupos`);
    const data = await res.json();
    setTodosGrupos(data);

    const variantesProducto = (producto.variantes || []).filter(v => v && v.talla !== 'Única');
    const ordenInicial  = [];
    const estadoInicial = {};

    data.forEach(grupo => {
      const opcionesConEstado = grupo.opciones.map(op => {
        const yaExiste = variantesProducto.some(v => {
          const partes = (v.talla || '').split(' / ').map(s => s.trim());
          return partes.includes(op.nombre) || v.color === op.nombre;
        });
        return { ...op, activo: yaExiste, nueva: false };
      });
      if (opcionesConEstado.some(o => o.activo)) {
        ordenInicial.push(grupo.id);
        estadoInicial[grupo.id] = opcionesConEstado;
      }
    });

    setOrdenGrupos(ordenInicial);
    setEstadoGrupos(estadoInicial);
  }

  function toggleOpcion(grupoId, opId) {
    setEstadoGrupos(prev => ({
      ...prev,
      [grupoId]: prev[grupoId].map(o => o.id === opId ? { ...o, activo: !o.activo } : o),
    }));
  }

  function handleDragStart(grupoId) { dragSrc.current = grupoId; }
  function handleDragOver(e)        { e.preventDefault(); }
  function handleDrop(grupoId) {
    if (!dragSrc.current || dragSrc.current === grupoId) return;
    const nuevo = [...ordenGrupos];
    const iA = nuevo.indexOf(dragSrc.current);
    const iB = nuevo.indexOf(grupoId);
    nuevo.splice(iA, 1);
    nuevo.splice(iB, 0, dragSrc.current);
    setOrdenGrupos(nuevo);
    dragSrc.current = null;
  }

  async function guardarNuevaOpcion(grupoId) {
    if (!nuevaOpcionNombre.trim()) return;
    const grupo  = todosGrupos.find(g => g.id === grupoId);
    const existe = estadoGrupos[grupoId]?.find(
      o => o.nombre.toLowerCase() === nuevaOpcionNombre.trim().toLowerCase()
    );
    if (existe) { alert(`⚠️ "${nuevaOpcionNombre}" ya existe`); return; }

    const res = await fetch(`${BASE_URL}/variante-opciones`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        grupo_id: grupoId,
        nombre: nuevaOpcionNombre.trim(),
        hex: grupo?.tipo === 'color' ? nuevaOpcionHex : null,
      }),
    });
    const nueva = await res.json();

    setEstadoGrupos(prev => ({
      ...prev,
      [grupoId]: [...(prev[grupoId] || []), { ...nueva, activo: true, nueva: true }],
    }));
    setTodosGrupos(prev => prev.map(g =>
      g.id === grupoId ? { ...g, opciones: [...g.opciones, nueva] } : g
    ));
    setNuevaOpcionNombre('');
    setNuevaOpcionHex('#ff9a9e');
    setAddingOpcion(null);
  }

  function confirmarNuevoGrupo() {
    if (!nuevoGrupoSel || nuevasOpciones.length === 0) return;
    const grupo = todosGrupos.find(g => g.id === nuevoGrupoSel);
    if (!grupo) return;
    setEstadoGrupos(prev => ({
      ...prev,
      [nuevoGrupoSel]: grupo.opciones.map(op => ({
        ...op,
        activo: nuevasOpciones.includes(op.id),
        nueva:  nuevasOpciones.includes(op.id),
      })),
    }));
    setOrdenGrupos(prev => [...prev, nuevoGrupoSel]);
    setNuevoGrupoAbierto(false);
    setNuevoGrupoSel(null);
    setNuevasOpciones([]);
  }

  async function handleGuardar() {
    if (!nombre || !precio) { alert('Completa nombre y precio'); return; }
    setGuardando(true);

    const precioLimpio = parseFloat(String(precio).replace(/,/g, '')) || 0;

    const gruposActivos = ordenGrupos
      .map(gId => ({
        grupo:    todosGrupos.find(g => g.id === gId),
        opciones: (estadoGrupos[gId] || []).filter(o => o.activo),
      }))
      .filter(g => g.grupo && g.opciones.length > 0);

    let combos = [];
    if (gruposActivos.length === 0) {
      combos = [{ talla: 'Única', color: 'Única', color_hex: '#cccccc', stock: 0 }];
    } else {
      let result = [[]];
      for (const { opciones } of gruposActivos) {
        const nuevas = [];
        for (const combo of result)
          for (const op of opciones)
            nuevas.push([...combo, op]);
        result = nuevas;
      }
      combos = result.map(combo => ({
        talla:     combo.map(c => c.nombre).join(' / '),
        color:     combo[0]?.nombre || 'Única',
        color_hex: combo[0]?.hex   || '#cccccc',
        stock: 0,
      }));
    }

    await fetch(`${BASE_URL}/productos/${producto.id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ emoji, nombre, descripcion, precio: precioLimpio, variantes: combos }),
    });

    setGuardando(false);
    onGuardado();
  }

  const gruposDisponibles = todosGrupos.filter(g => !ordenGrupos.includes(g.id));

  return (
    <div style={S.overlay} onClick={e => e.target === e.currentTarget && onCerrar()}>
      <div style={S.modal}>
        <div style={S.handle} />
        <div style={S.header}>
          <div style={S.title}>Editar producto</div>
          <button style={S.closeBtn} onClick={onCerrar}>✕</button>
        </div>
        <div style={S.body}>

          {/* Emoji */}
          <div style={S.group}>
            <label style={S.label}>Ícono del producto</label>
            <div style={S.emojiRow}>
              {EMOJIS.map(e => (
                <button key={e} style={{ ...S.emojiBtn, background: emoji === e ? '#e8f5e9' : '#f5f5f5', border: emoji === e ? '2px solid #25D366' : '2px solid transparent' }} onClick={() => setEmoji(e)}>{e}</button>
              ))}
            </div>
          </div>

          {/* Nombre */}
          <div style={S.group}>
            <label style={S.label}>Nombre del producto</label>
            <input style={S.input} value={nombre} onChange={e => setNombre(e.target.value)} />
          </div>

          {/* Descripción */}
          <div style={S.group}>
            <label style={S.label}>Descripción</label>
            <textarea style={{ ...S.input, height: 72, resize: 'none' }} value={descripcion} onChange={e => setDescripcion(e.target.value)} />
          </div>

          {/* Precio */}
          <div style={S.group}>
            <label style={S.label}>Precio ($MXN)</label>
            <div style={{ position: 'relative' }}>
              <span style={S.pesosSign}>$</span>
              <input
                style={{ ...S.input, paddingLeft: 24 }}
                type="text"
                value={precio}
                onChange={e => setPrecio(e.target.value.replace(/[^0-9.]/g, ''))}
                onBlur={e => {
                  const num = parseFloat(e.target.value.replace(/,/g, '')) || 0;
                  setPrecio(num.toLocaleString('es-MX', { minimumFractionDigits: 2 }));
                }}
              />
            </div>
          </div>

          {/* Variantes */}
          <div style={S.group}>
            <label style={S.label}>Variantes del producto</label>
            <div style={S.ordenHint}>☰ Arrastra para reordenar · Toca para activar o desactivar</div>

            <div style={S.leyenda}>
              <span style={S.leyendaItem}><span style={{ ...S.leyendaDot, background: '#25D366' }} /> Activa</span>
              <span style={S.leyendaItem}><span style={{ ...S.leyendaDot, background: '#ccc' }} /> Inactiva</span>
              <span style={S.leyendaItem}><span style={{ ...S.leyendaDot, background: '#128C7E' }} /> Nueva</span>
            </div>

            {ordenGrupos.map(grupoId => {
              const grupo    = todosGrupos.find(g => g.id === grupoId);
              if (!grupo) return null;
              const opciones = grupo.tipo === 'talla'
                ? ordenarOpciones(estadoGrupos[grupoId] || [])
                : (estadoGrupos[grupoId] || []);
              const activasCount = opciones.filter(o => o.activo).length;

              return (
                <div
                  key={grupoId}
                  style={S.grupoCard}
                  draggable
                  onDragStart={() => handleDragStart(grupoId)}
                  onDragOver={handleDragOver}
                  onDrop={() => handleDrop(grupoId)}
                >
                  <div style={S.grupoHdr}>
                    <span style={S.dragHandle}>☰</span>
                    <span style={S.grupoNombre}>{grupo.nombre}</span>
                    <span style={S.badge}>{activasCount} activas</span>
                  </div>
                  <div style={S.grupoBody}>
                    {opciones.map(op => (
                      <div
                        key={op.id}
                        style={{ ...S.vchip, ...(op.activo ? (op.nueva ? S.vchipNueva : S.vchipActivo) : S.vchipInactivo) }}
                        onClick={() => toggleOpcion(grupoId, op.id)}
                      >
                        {op.hex && (
                          <span style={{ width: 9, height: 9, borderRadius: '50%', background: op.hex, display: 'inline-block', border: '1px solid rgba(0,0,0,.1)', flexShrink: 0, opacity: op.activo ? 1 : 0.4 }} />
                        )}
                        <span style={{ opacity: op.activo ? 1 : 0.45 }}>{op.nombre}</span>
                        {op.activo && <span style={{ fontSize: 10, color: op.nueva ? '#0a6644' : '#25D366' }}>✓</span>}
                      </div>
                    ))}

                    {addingOpcion === grupoId ? (
                      <div style={S.addOpcionRow}>
                        {grupo.tipo === 'color' && (
                          <input type="color" style={S.colorPicker} value={nuevaOpcionHex} onChange={e => setNuevaOpcionHex(e.target.value)} />
                        )}
                        <input
                          style={S.addOpcionInput}
                          placeholder={grupo.tipo === 'color' ? 'Nombre del color' : 'Nueva opción'}
                          value={nuevaOpcionNombre}
                          onChange={e => setNuevaOpcionNombre(e.target.value)}
                          onKeyDown={e => e.key === 'Enter' && guardarNuevaOpcion(grupoId)}
                          autoFocus
                        />
                        <button style={S.confirmBtn} onClick={() => guardarNuevaOpcion(grupoId)}>✓</button>
                        <button style={S.cancelBtn} onClick={() => { setAddingOpcion(null); setNuevaOpcionNombre(''); }}>✕</button>
                      </div>
                    ) : (
                      <button style={S.addOpcionBtn} onClick={() => setAddingOpcion(grupoId)}>＋ opción</button>
                    )}
                  </div>
                  <div style={S.grupoNote}>Stock se gestiona en Inventario</div>
                </div>
              );
            })}

            <button
              style={{ ...S.toggleNuevoBtn, opacity: gruposDisponibles.length === 0 ? 0.5 : 1, cursor: gruposDisponibles.length === 0 ? 'default' : 'pointer' }}
              disabled={gruposDisponibles.length === 0}
              onClick={() => { setNuevoGrupoAbierto(!nuevoGrupoAbierto); setNuevoGrupoSel(null); setNuevasOpciones([]); }}
            >
              {gruposDisponibles.length === 0 ? 'No hay más variantes disponibles' : nuevoGrupoAbierto ? '▲ Cancelar' : '＋ Agregar variante'}
            </button>

            {nuevoGrupoAbierto && (
              <div style={S.nuevoGrupoBody}>
                <div style={S.nuevoGrupoLabel}>Tipo de variante</div>
                <div style={S.grupoSelRow}>
                  {gruposDisponibles.map(g => (
                    <button
                      key={g.id}
                      style={{ ...S.grupoSelBtn, ...(nuevoGrupoSel === g.id ? S.grupoSelBtnSel : {}) }}
                      onClick={() => { setNuevoGrupoSel(g.id); setNuevasOpciones([]); }}
                    >
                      {g.nombre}
                    </button>
                  ))}
                </div>

                {nuevoGrupoSel && (() => {
                  const g = todosGrupos.find(x => x.id === nuevoGrupoSel);
                  if (!g) return null;
                  return (
                    <div style={S.chipsNuevas}>
                      {g.opciones.map(op => (
                        <button
                          key={op.id}
                          style={{ ...S.chipNueva, ...(nuevasOpciones.includes(op.id) ? S.chipNuevaSel : {}) }}
                          onClick={() => setNuevasOpciones(prev => prev.includes(op.id) ? prev.filter(x => x !== op.id) : [...prev, op.id])}
                        >
                          {op.hex && <span style={{ width: 9, height: 9, borderRadius: '50%', background: op.hex, display: 'inline-block', border: '1px solid rgba(0,0,0,.1)', flexShrink: 0 }} />}
                          {op.nombre}
                        </button>
                      ))}
                    </div>
                  );
                })()}

                {nuevasOpciones.length > 0 && (
                  <>
                    <div style={S.preview}>Se agregarán <strong>{nuevasOpciones.length}</strong> opciones al producto</div>
                    <button style={S.confirmarNuevoBtn} onClick={confirmarNuevoGrupo}>
                      Agregar {nuevasOpciones.length} opción{nuevasOpciones.length > 1 ? 'es' : ''}
                    </button>
                  </>
                )}
              </div>
            )}
          </div>

          <button
            style={{ ...S.saveBtn, opacity: guardando ? 0.7 : 1 }}
            onClick={handleGuardar}
            disabled={guardando}
          >
            {guardando ? '⏳ Guardando...' : '✓ Guardar cambios'}
          </button>

        </div>
      </div>
    </div>
  );
}

const S = {
  overlay:           { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 200, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' },
  modal:             { background: 'white', borderRadius: '24px 24px 0 0', width: '100%', maxWidth: 430, maxHeight: '92vh', overflowY: 'auto' },
  handle:            { width: 40, height: 4, background: '#e0e0e0', borderRadius: 2, margin: '12px auto 0' },
  header:            { padding: '16px 20px 12px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid #E4EDE8' },
  title:             { fontSize: 17, fontWeight: 800, color: '#0D1F1A' },
  closeBtn:          { width: 32, height: 32, background: '#F0F4F0', borderRadius: '50%', border: 'none', cursor: 'pointer', fontSize: 16, color: '#7A8F89' },
  body:              { padding: 20 },
  group:             { marginBottom: 16 },
  label:             { display: 'block', fontSize: 12, fontWeight: 700, color: '#7A8F89', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 6 },
  input:             { width: '100%', background: '#F0F4F0', border: '1.5px solid #E4EDE8', borderRadius: 12, padding: '12px 14px', fontSize: 14, color: '#0D1F1A', outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box' },
  pesosSign:         { position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: '#7A8F89', fontSize: 14, pointerEvents: 'none' },
  emojiRow:          { display: 'flex', flexWrap: 'wrap', gap: 8 },
  emojiBtn:          { width: 44, height: 44, borderRadius: 12, fontSize: 22, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  ordenHint:         { fontSize: 11, color: '#7A8F89', marginBottom: 8 },
  leyenda:           { display: 'flex', gap: 12, marginBottom: 10, flexWrap: 'wrap' },
  leyendaItem:       { display: 'flex', alignItems: 'center', gap: 4, fontSize: 10, color: '#7A8F89' },
  leyendaDot:        { width: 8, height: 8, borderRadius: '50%', display: 'inline-block' },
  grupoCard:         { border: '1px solid #E4EDE8', borderRadius: 14, overflow: 'hidden', marginBottom: 8 },
  grupoHdr:          { display: 'flex', alignItems: 'center', gap: 8, padding: '9px 12px', background: '#f8fcf9', borderBottom: '1px solid #E4EDE8' },
  dragHandle:        { fontSize: 16, color: '#7A8F89', cursor: 'grab', flexShrink: 0 },
  grupoNombre:       { fontSize: 13, fontWeight: 700, color: '#0D1F1A', flex: 1 },
  badge:             { fontSize: 10, background: '#E4EDE8', borderRadius: 20, padding: '2px 8px', color: '#7A8F89' },
  grupoBody:         { padding: '10px 12px', display: 'flex', flexWrap: 'wrap', gap: 6 },
  vchip:             { display: 'flex', alignItems: 'center', gap: 5, borderRadius: 20, padding: '5px 11px', fontSize: 12, border: '1px solid #E4EDE8', cursor: 'pointer', userSelect: 'none' },
  vchipActivo:       { borderColor: '#25D366', background: '#f0fff5', color: '#128C7E', fontWeight: 700 },
  vchipNueva:        { borderColor: '#128C7E', background: '#d6f5e3', color: '#0a6644', fontWeight: 700 },
  vchipInactivo:     { background: '#F0F4F0', color: '#7A8F89' },
  addOpcionRow:      { display: 'flex', alignItems: 'center', gap: 6, width: '100%', marginTop: 4 },
  addOpcionInput:    { flex: 1, background: '#F0F4F0', border: '1.5px solid #E4EDE8', borderRadius: 10, padding: '6px 10px', fontSize: 12, color: '#0D1F1A', outline: 'none', fontFamily: 'inherit' },
  colorPicker:       { width: 30, height: 30, borderRadius: 8, border: '1px solid #E4EDE8', cursor: 'pointer', padding: 2, flexShrink: 0 },
  confirmBtn:        { width: 30, height: 30, background: '#25D366', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 700, flexShrink: 0 },
  cancelBtn:         { width: 30, height: 30, background: '#F0F4F0', color: '#7A8F89', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 12, flexShrink: 0 },
  addOpcionBtn:      { border: '1.5px dashed #25D366', borderRadius: 20, padding: '4px 10px', fontSize: 12, color: '#128C7E', cursor: 'pointer', background: 'none', fontFamily: 'inherit' },
  grupoNote:         { fontSize: 11, color: '#128C7E', background: '#f0fff5', padding: '5px 12px', borderTop: '1px solid #d0f0e0' },
  toggleNuevoBtn:    { width: '100%', background: 'none', border: '1.5px dashed #25D366', borderRadius: 14, padding: 11, color: '#128C7E', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', marginBottom: 8 },
  nuevoGrupoBody:    { background: '#F0F4F0', borderRadius: 12, padding: 12, marginBottom: 8 },
  nuevoGrupoLabel:   { fontSize: 11, color: '#7A8F89', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8 },
  grupoSelRow:       { display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 10 },
  grupoSelBtn:       { flex: 1, padding: '8px 6px', borderRadius: 10, border: '1px solid #E4EDE8', background: 'white', cursor: 'pointer', fontSize: 12, fontWeight: 700, color: '#7A8F89', fontFamily: 'inherit', textAlign: 'center' },
  grupoSelBtnSel:    { borderColor: '#25D366', background: '#f0fff5', color: '#128C7E' },
  chipsNuevas:       { display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 10 },
  chipNueva:         { border: '1px solid #E4EDE8', borderRadius: 20, padding: '5px 12px', fontSize: 12, color: '#7A8F89', cursor: 'pointer', background: 'white', fontFamily: 'inherit', display: 'flex', alignItems: 'center', gap: 5 },
  chipNuevaSel:      { borderColor: '#25D366', background: '#f0fff5', color: '#128C7E', fontWeight: 700 },
  preview:           { background: '#f0fff5', borderRadius: 8, padding: '7px 10px', fontSize: 12, color: '#128C7E', marginBottom: 8 },
  confirmarNuevoBtn: { width: '100%', background: '#25D366', color: 'white', border: 'none', borderRadius: 10, padding: 10, fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' },
  saveBtn:           { width: '100%', background: 'linear-gradient(135deg,#25D366,#128C7E)', color: 'white', border: 'none', borderRadius: 16, padding: 16, fontSize: 15, fontWeight: 700, cursor: 'pointer', marginTop: 8 },
};

export default ModalEditarProducto;